module.exports = __webpack_public_path__ + "img/search-coupon.cee9868f.svg";